import { render, staticRenderFns } from "./traceabilityModal.vue?vue&type=template&id=2f95ff3a&scoped=true&"
import script from "./traceabilityModal.vue?vue&type=script&lang=js&"
export * from "./traceabilityModal.vue?vue&type=script&lang=js&"
import style0 from "./traceabilityModal.vue?vue&type=style&index=0&id=2f95ff3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f95ff3a",
  null
  
)

export default component.exports